import React, { useState, useEffect } from 'react';
import {
  AvailabilityMiniModal as PSAvailabilityMiniModal
} from '@ps-design-system/components/calendar/AvailabilityMiniModal';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import { toast } from '@ps-design-system/components/Toast';

const AvailabilityMiniModal = ({
  profileSSOid,
  onConfirm,
  onDismiss,
  isModalVisible,
  intl
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isModalVisible) {
      analytics.track('viewed_mini_availability_modal', {
        ssoId: profileSSOid
      });
    }
  }, [isModalVisible]);

  const handleDismiss = () => {
    analytics.track('clicked_dismiss_mini_availability_modal', {
      ssoId: profileSSOid
    });

    const reminderLaterText = intl.formatMessage({
      id: 'calendar.toast.confirm_availability_remind_later',
      defaultMessage: 'We will remind you to confirm your calendar later.'
    });

    toast({
      title: '',
      description: reminderLaterText,
      variant: 'white',
      duration: 5000
    });

    onDismiss();
  };

  const handleConfirm = async () => {
    analytics.track('clicked_confirm_mini_availability_modal', {
      ssoId: profileSSOid
    });

    setIsLoading(true);

    await onConfirm();

    const availabilityUpdatedText = intl.formatMessage({
      id: 'calendar.toast.confirm_availability_success',
      defaultMessage: 'Thanks for confirming your availability.'
    });

    toast({
      title: '',
      description: availabilityUpdatedText,
      variant: 'success',
      duration: 5000
    });

    setIsLoading(false);
    onDismiss();
  };

  return (
    <PSAvailabilityMiniModal
      isVisible={isModalVisible}
      onDismiss={handleDismiss}
      onConfirm={handleConfirm}
      isLoading={isLoading}
    />
  );
};

AvailabilityMiniModal.propTypes = {
  profileSSOid: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  isModalVisible: PropTypes.bool,
  intl: intlShape.isRequired
};

export default injectIntl(AvailabilityMiniModal);
